import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UpdateService } from './services/update.service';
import { SeoService } from '@edt/services/seo.service';
import { GlobalStore } from './store/app.store';
import { SchemaOrg } from '@edt/models/seo-data';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  protected readonly updateService = inject(UpdateService);
  readonly #seoSrv = inject(SeoService);
  readonly #globalStore = inject(GlobalStore);

  ngOnInit(): void {
    const siteInfo = this.#globalStore.siteInfo();
    const baseUrl = siteInfo.site ?? '';

    const schemas: SchemaOrg[] = [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: baseUrl,
        logo: siteInfo.logo ?? `${baseUrl}/logo.png`,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: siteInfo,
          contactType: 'customer service',
          availableLanguage: 'Spanish',
        },
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: baseUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${baseUrl}/buscar?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
    ];

    this.#seoSrv.setGlobalJsonLd(schemas);
  }
}
